import { useEffect, useState } from "react";
import { getCurrentResume } from "@/lib/atsScores";
import { api } from "@/lib/api";

const KEY = "rpopro_apply_streak";
const EVT = "rpopro:streak";
const day = (d = new Date()) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
const tailoredNames = () => { try { return (JSON.parse(localStorage.getItem("rpopro_tailored")) || []).map((t) => t.file_name); } catch { return []; } };

export const noteApply = (forceTailored = false) => {
  if (!forceTailored && !tailoredNames().includes(getCurrentResume())) return;
  const d = day();
  const days = read();
  if (days.includes(d)) return;
  localStorage.setItem(KEY, JSON.stringify([...days, d].slice(-400)));
  window.dispatchEvent(new CustomEvent(EVT));
  api.post("/streaks/tailored-apply", { day: d }).catch(() => {});
};

export const streakStats = (days = read()) => {
  const set = new Set(days);
  const back = (n) => { const d = new Date(); d.setDate(d.getDate() - n); return day(d); };
  let start = set.has(back(0)) ? 0 : set.has(back(1)) ? 1 : -1;
  let current = 0;
  if (start >= 0) while (set.has(back(start + current))) current += 1;
  const sorted = [...set].sort();
  let best = 0, run = 0, prev = null;
  sorted.forEach((s) => { const t = new Date(`${s}T12:00:00`); run = prev && (t - prev) / 864e5 < 1.5 ? run + 1 : 1; best = Math.max(best, run); prev = t; });
  const week = Array.from({ length: 7 }, (_, i) => ({ d: back(6 - i), on: set.has(back(6 - i)) }));
  return { current, best, today: set.has(back(0)), week, total: set.size };
};

export const useStreak = () => {
  const [s, setS] = useState(() => streakStats());
  useEffect(() => {
    const f = () => setS(streakStats());
    window.addEventListener(EVT, f);
    window.addEventListener("storage", f);
    return () => { window.removeEventListener(EVT, f); window.removeEventListener("storage", f); };
  }, []);
  return s;
};
